var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoDocuments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 250,
  height: 200,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h250v200H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EEF6FF",
  fillRule: "evenodd",
  d: "M207 65a7 7 0 1 1 0 14h-40a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-10.174c-4.874 0-8.826 3.134-8.826 7q0 3.866 6 7a7 7 0 1 1 0 14H93a7 7 0 1 1 0-14H54a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H69a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm0 28a7 7 0 1 1 0 14 7 7 0 0 1 0-14",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m153.672 64 9.302 67.843.835 6.806a4 4 0 0 1-3.482 4.458l-58.56 7.19a4 4 0 0 1-4.458-3.483l-9.016-73.427a2 2 0 0 1 1.741-2.23l.021-.001 4.859-.546m3.928-.44 4.587-.515z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M154.91 63.83a1.25 1.25 0 1 0-2.477.34zm8.064 68.013 1.24-.153-.002-.017zm.835 6.806 1.241-.152zm-3.482 4.458.152 1.24zm-58.56 7.19.152 1.241zm-4.458-3.483 1.24-.152zm-9.016-73.427-1.24.152zm1.762-2.231.14 1.242zm4.998.697a1.25 1.25 0 1 0-.279-2.485zm3.65-2.925a1.25 1.25 0 0 0 .278 2.484zm4.866 1.97a1.25 1.25 0 0 0-.279-2.485zm48.864-6.728 9.302 67.843 2.477-.34-9.302-67.843zm9.3 67.825.836 6.806 2.481-.304-.836-6.807zm.836 6.806a2.75 2.75 0 0 1-2.395 3.065l.305 2.481a5.25 5.25 0 0 0 4.571-5.85zm-2.395 3.065-58.56 7.19.305 2.482 58.56-7.191zm-58.56 7.19a2.75 2.75 0 0 1-3.064-2.394l-2.482.305a5.25 5.25 0 0 0 5.851 4.571zm-3.064-2.394-9.016-73.428-2.482.305 9.016 73.428zm-9.016-73.428a.75.75 0 0 1 .653-.835l-.305-2.482a3.25 3.25 0 0 0-2.83 3.622zm.653-.835.008-.001-.28-2.485-.033.004zm.008-.001 4.858-.545-.279-2.485-4.858.545zm8.787-.986 4.587-.515-.279-2.484-4.587.515z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#EEF6FF",
  fillRule: "evenodd",
  d: "m151.14 68.27 8.42 61.483.757 6.168c.244 1.987-1.15 3.794-3.114 4.035l-52.442 6.439c-1.963.241-3.753-1.175-3.997-3.162l-8.15-66.376a2 2 0 0 1 1.742-2.23l6.487-.796",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 2.5,
  d: "M107.922 54a2.75 2.75 0 0 1 2.75-2.75h45.557c.729 0 1.428.29 1.944.805l13.443 13.435a2.75 2.75 0 0 1 .806 1.945V130a2.75 2.75 0 0 1-2.75 2.75h-59a2.75 2.75 0 0 1-2.75-2.75z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M156.672 52.403V64a3 3 0 0 0 3 3h7.933M118 118h26m-26-51h26zm0 12h43zm0 13h43zm0 13h43z"
})));
export { SvgNoDocuments as ReactComponent };
export default __webpack_public_path__ + "assets/images/NoDocuments.700843dc1d8c7924086e6518a7637ac2.svg";